import React from 'react'
import './services.css'
import { BiCheck } from 'react-icons/bi'
import { frontend, backend } from './data'

const Services = () => {
  return (
    <section id='services'>
        <h5>What I Offer</h5>
        <h2>Services</h2>

        <div className="container services__container">
            <article className="service">
                <div className="service__head">
                    <h3>Front End & Mobile</h3>
                </div>

                <ul className="service__list">
                    {
                        frontend.map(({id, value}) => {
                            return(
                                <li key={id}>
                                    <BiCheck className="service__list-icon" />
                                    <p>{value}</p>
                                </li>
                            )
                        })
                    }
                </ul>
            </article>

            <article className="service">
                <div className="service__head">
                    <h3>Back End Solutions</h3>
                </div>

                <ul className="service__list">
                    {
                        backend.map(({id, value}) => {
                            return(
                                <li key={id}>
                                    <BiCheck className="service__list-icon" />
                                    <p>{value}</p>
                                </li>
                            )
                        })
                    }
                </ul>
            </article>
        </div>
    </section>
  )
}

export default Services